import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaCotaPriceRequest } from '../interface/entuba/CotaPrice/IEntubaCotaPriceRequest';
import { IEntubaResponse } from "../interface/entuba/IEntubaResponse";

enum EntubaReceivableServiceEnum {
    base = "/",
    start = "/start",
    getAll = "",
    get = "/get/",
    getReceivables = "/receivables_types"
}

export default class EntubaReceivableService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/wallet/cota/receivables");
    }

    public getAll = async (): Promise<IEntubaResponse[]> => await this.GET(EntubaReceivableServiceEnum.getAll);
    public start = async (data: IEntubaCotaPriceRequest) => await this.POST(EntubaReceivableServiceEnum.start, data);
    public getReceivables = async () => await this.GET(EntubaReceivableServiceEnum.getReceivables);
}


// WEBPACK FOOTER //
// ./src/services/api/EntubaReceivables.service.ts